import axios from 'axios';

/**
 * Initialize global axios configuration
 * Sets up base URL and default headers for all axios requests
 */
export const initializeAxiosConfig = (getApiHostUrlFunc: () => string): void => {
  try {
    // Set global base URL for API requests
    axios.defaults.baseURL = getApiHostUrlFunc();
    
    // Set global timeout
    axios.defaults.timeout = 30000;
    
    console.log('Axios global configuration initialized with base URL:', axios.defaults.baseURL);
  } catch (error) {
    console.error('Failed to initialize axios configuration:', error);
  }
};